'use strict';

const Dispatcher = require('dispatcher/SchedulerAppDispatcher'),
  Constants = require('constants/AppConstants'),
  ActionType = Constants.ActionTypes,
  DashboardActionCreators = {
    
    addOrderDraft(order) {
      Dispatcher.dispatch({
        type: ActionType.NEW_ORDER_DRAFT,
        order
      });
    },
    
    fetchScheduleBoardByDate(date) {
      Dispatcher.dispatch({
        type: ActionType.FETCH_SCHEDULE_BOARD,
        date
      });
    },
    
    saveChangedUserTaskName({date, name, id, originalName}) {
      Dispatcher.dispatch({
        type: ActionType.SAVING_SCHEDULE_BOARD,
        date,
        name,
        id,
        originalName
      });
    },
    
    addUserTaskName({listId, listName, date, note, id, name, checked}) {
      Dispatcher.dispatch({
        type: ActionType.ADDING_NOTE_SCHEDULE_BOARD,
        note,
        name,
        date,
        id,
        listId,
        listName,
        checked
      });
    },
    
    deleteUserTaskName(id, listName) {
      Dispatcher.dispatch({
        type: ActionType.DELETING_SCHEDULE_BOARD,
        id,
        listName
      });
    },
    
    deleteUserTaskNameSuccess() {
      Dispatcher.dispatch({type: ActionType.DELETING_SCHEDULE_BOARD_SUCCESS});
    },
    
    deleteUserTaskNameFailure() {
      Dispatcher.dispatch({type: ActionType.DELETING_SCHEDULE_BOARD_FAILURE});
    },
  
    saveChangedUserTaskNameSuccess() {
      Dispatcher.dispatch({type: ActionType.SAVING_SCHEDULE_BOARD_SUCCESS});
    },
  
    addUserTaskNameSuccess() {
      Dispatcher.dispatch({type: ActionType.ADDING_NOTE_SCHEDULE_BOARD_SUCCESS});
    },
    
    saveChangedUserTaskNameFailure() {
      Dispatcher.dispatch({type: ActionType.SAVING_SCHEDULE_BOARD_FAILURE});
    },
  
    addUserTaskNameFailure() {
      Dispatcher.dispatch({type: ActionType.ADDING_NOTE_SCHEDULE_BOARD_FAILURE});
    },
  
    fetchScheduleBoardByDateSuccess(data) {
      Dispatcher.dispatch({
        type: ActionType.FETCH_SCHEDULE_BOARD_SUCCESS,
        data
      });
    },
    
    fetchScheduleBoardByDateFailure() {
      Dispatcher.dispatch({
        type: ActionType.FETCH_SCHEDULE_BOARD_FAILURE
      });
    },
    
    changeOrderDraft(order) {
      Dispatcher.dispatch({
        type: ActionType.CHANGE_ORDER_DRAFT,
        order
      });
    },
    
    removeOrderDraft(order) {
      Dispatcher.dispatch({
        type: ActionType.REMOVED_ORDER_DRAFT,
        order
      });
    },
    
    newOrder(order) {
      Dispatcher.dispatch({
        type: ActionType.NEW_ORDER,
        order
      });
    },
    
    changeToggle(lastToggleChanged, isBHAllowed, isFVAllowed, isBTAllowed) {
      Dispatcher.dispatch({
        type: ActionType.DASHBOARD_MODAL_CHANGE_TOGGLE,
        isBHAllowed,
        isFVAllowed,
        isBTAllowed,
        lastToggleChanged
      });
    },
    
    changeOrder(order) {
      Dispatcher.dispatch({
        type: ActionType.CHANGE_ORDER,
        order
      });
    },
    
    removedOrder() {
      Dispatcher.dispatch({
        type: ActionType.REMOVED_ORDER
      });
    },
    
    savingDraft() {
      Dispatcher.dispatch({
        type: ActionType.SAVE_DRAFT
      });
    },
    
    savingDraftSuccess() {
      Dispatcher.dispatch({
        type: ActionType.SAVE_DRAFT_SUCCESS
      });
    },
    
    showLoading() {
      Dispatcher.dispatch({
        type: ActionType.SHOW_LOADING
      });
    },
    
    hideLoading() {
      Dispatcher.dispatch({
        type: ActionType.HIDE_LOADING
      });
    },
    
    
    savingDraftFailure() {
      Dispatcher.dispatch({
        type: ActionType.SAVE_DRAFT_FAILURE
      });
    },
    
    closeModal() {
      Dispatcher.dispatch({
        type: ActionType.DASHBOARD_MODAL_CLOSE_MODAL
      });
    },
    
    publishingDraft() {
      Dispatcher.dispatch({
        type: ActionType.PUBLISHING_DRAFT
      });
    },
    
    updateDashboardWithUserAdmin() {
      Dispatcher.dispatch({
        type: ActionType.PUBLISHING_CHANGE_ADMIN_DRAFT
      });
    },
    
    publishingSuccess(from, to) {
      Dispatcher.dispatch({
        type: ActionType.PUBLISHING_DRAFT_SUCCESS,
        from,
        to
      });
    },
    
    publishingFailure() {
      Dispatcher.dispatch({
        type: ActionType.PUBLISHING_DRAFT_FAILURE
      });
    },
    
    undoDraft() {
      Dispatcher.dispatch({
        type: ActionType.UNDO_DRAFT
      });
    },
    
    undoDraftSuccess() {
      Dispatcher.dispatch({
        type: ActionType.UNDO_DRAFT_SUCCESS
      });
    },
    
    undoDraftFailure() {
      Dispatcher.dispatch({
        type: ActionType.UNDO_DRAFT_FAILURE
      });
    },
    
    redoDraft() {
      Dispatcher.dispatch({
        type: ActionType.REDO_DRAFT
      });
    },
    
    redoDraftSuccess() {
      Dispatcher.dispatch({
        type: ActionType.REDO_DRAFT_SUCCESS
      });
    },
    
    redoDraftFailure() {
      Dispatcher.dispatch({
        type: ActionType.REDO_DRAFT_FAILURE
      });
    },
    
    addedTank() {
      Dispatcher.dispatch({
        type: ActionType.ADDED_TANK
      });
    },
    
    changedTank() {
      Dispatcher.dispatch({
        type: ActionType.CHANGED_TANK
      });
    },
    
    needFetchBrewingNotes() {
      Dispatcher.dispatch({
        type: ActionType.BREWING_NOTE_NEED_FETCH
      });
    },
    
    needFetchPackagingNotes() {
      Dispatcher.dispatch({
        type: ActionType.PACKAGING_NOTE_NEED_FETCH
      });
    },
    
    deletedTank() {
      Dispatcher.dispatch({
        type: ActionType.DELETED_TANK
      });
    },
    
    executeBatchOperationsEnd(batchNumber) {
      Dispatcher.dispatch({
        type: ActionType.PERFORM_BATCH_OPERATION_END,
        batchNumber
      });
    },
    
    forceRenderDashboard() {
      Dispatcher.dispatch({type: ActionType.FORCE_MANUAL_DRAWING_DASHBOARD});
    },
    
    forceReFetchAndRenderDashboard(from, to) {
      Dispatcher.dispatch({type: ActionType.FORCE_MANUAL_RE_FETCH_AND_DRAWING_DASHBOARD, from, to});
    },
  
    removeUserTask({id, listId}) {
      Dispatcher.dispatch({
        type: ActionType.DELETING_USER_TASK,
        id,
        listId
      });
    },
    
    removeUserTaskSuccess() {
      Dispatcher.dispatch({
        type: ActionType.DELETING_USER_TASK_SUCCESS
      });
    },
    
    removeUserTaskFailure() {
      Dispatcher.dispatch({
        type: ActionType.DELETING_USER_TASK_FAILURE
      });
    }
  };

module.exports = DashboardActionCreators;



/** WEBPACK FOOTER **
 ** ./src/actions/DashboardActionCreators.js
 **/